export function validateRecommendModel(appContext, model){
    const { stores: { DataTypesStore } } = appContext;

    let badRecommendations = []
    let badCategories = []

    //each group
    for (let i = 0; i < model.groups.length; ++i) {
        //todo - look for unresolved group names
        for (let j = 0; j < model.groups[i].categories.length; ++j) {

            //look for unresolved category names
            let categoryModel = model.groups[i].categories[j] 
            var recIndex = DataTypesStore.getRecommendCategories().findIndex((rec) => rec.categoryId === categoryModel.name);
            if (recIndex < 0){
                let badCategory = {}
                badCategory.group = model.groups[i].name
                badCategory.reason = 'missing category'
                badCategory.type = model.groups[i].type
                badCategory.category = model.groups[i].categories[j].name
                badCategories.push(badCategory) 
            }

            for (let k = 0; k < model.groups[i].categories[j].recommendations.length; ++k) {
                //look for unresolved recommendations
                let recommendation = model.groups[i].categories[j].recommendations[k] 
                let sourceRecommendation = DataTypesStore.getRecommendationTypes().find((r) => r.recommendId === recommendation.recommendId); //findNodeByRecommendId(recommendations, recommendation.recommendId);
                if (!sourceRecommendation){
                    let badRecommendation = {} 
                    badRecommendation.group = model.groups[i].name
                    badRecommendation.reason = 'missing recommendation'
                    badRecommendation.type = model.groups[i].type
                    badRecommendation.category = model.groups[i].categories[j].name
                    badRecommendation.name =  recommendation.name
                    badRecommendation.explanation = recommendation.explanation;
                    badRecommendation.recommendationId = recommendation.recommendId
                    badRecommendations.push(badRecommendation)

                    recommendation.recommendId = '';            // clear the recommendId as part of the validation
                }
            }
        }
    }

    return ({
        badCategories,
        badRecommendations
    })
}


export function validateRecommendModels(appContext, models){
    for (let i = 0; i < models.length; ++i) {
        let badItems = validateRecommendModel(appContext, models[i])
        if (badItems.badRecommendations.length > 0 || badItems.badCategories.length > 0){
            models[i].valid = false
        }else{
            models[i].valid = true 
        }
    }
    return models
}

